export default __webpack_public_path__ + "static/media/style-angelusPaseo.21666a4a.jpg";